import { render, staticRenderFns } from "./rewardAndPunishmentNotification.vue?vue&type=template&id=2bae910c&scoped=true"
import script from "./rewardAndPunishmentNotification.vue?vue&type=script&lang=js"
export * from "./rewardAndPunishmentNotification.vue?vue&type=script&lang=js"
import style0 from "./rewardAndPunishmentNotification.vue?vue&type=style&index=0&id=2bae910c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae910c",
  null
  
)

export default component.exports